var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeStatic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1 9.075C34.65 7.5 33.525 6.375 31.95 5.925C29.25 5.25 17.775 5.25 17.775 5.25C17.775 5.25 6.52501 5.25 3.60001 5.925C2.02501 6.375 0.899993 7.5 0.449993 9.075C-6.87316e-06 12 0 17.85 0 17.85C0 17.85 6.83963e-06 23.7 0.675007 26.625C1.12501 28.2 2.24999 29.325 3.82499 29.775C6.52499 30.45 18 30.45 18 30.45C18 30.45 29.25 30.45 32.175 29.775C33.75 29.325 34.875 28.2 35.325 26.625C36 23.7 36 17.85 36 17.85C36 17.85 36 12 35.1 9.075ZM14.4 23.25V12.45L23.85 17.85L14.4 23.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeStatic);
export default __webpack_public_path__ + "static/media/youtube-static.95ce785f1f8d0e61ee42ed51ae12a269.svg";
export { ForwardRef as ReactComponent };